import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Link,
} from '@mui/material'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useRecoilState } from 'recoil'
import { formDataState } from '../helpers'
import CheckField from '../layout/checkfield.component'
import Layout from '../layout/layout.component'

function Step3({ step, handleBack, handleSubmit }) {
  const [formData, setFormData] = useRecoilState(formDataState)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const [isConsented, setIsConsent] = useState(false)

  const descriptionText = (
    <>
      If there are no changes, please click{' '}
      <strong>&quot;Register&quot;</strong> button to confirm. <br />
      <br />
      If the details are incorrect, please click{' '}
      <strong>&quot;Back&quot;</strong> to resubmit your information.
    </>
  )

  const onBiicChange = (e) => {
    setFormData({
      ...formData,
      biic: e.target.value,
    })
  }

  const onBiisChange = (e) => {
    setFormData({
      ...formData,
      biis: e.target.value,
    })
  }

  return (
    <Layout
      step={step}
      content={
        <>
          <Grid container columnSpacing={8}>
            <Grid
              container
              item
              xs={12}
              md={6}
              height="fit-content"
              columnSpacing={2}
            >
              <Grid item xs={12}>
                <Typography variant="h4" sx={{ mb: '20px' }}>
                  Your Personal Information
                </Typography>
              </Grid>
              <CheckField xs={6} label="Name" value={formData.name} />
              <CheckField
                xs={6}
                label={formData.idTypeLabel}
                value={formData.idNo}
              />
              <CheckField
                xs={6}
                label="Date of Birth"
                value={format(formData.dob, 'dd MMM yyyy')}
              />
              <CheckField
                xs={6}
                label="Nationality"
                value={formData.nationalityLabel}
              />
              <CheckField xs={6} label="Address" value={formData.address} />
              {formData.email ? (
                <CheckField xs={6} label="Email" value={formData.email} />
              ) : null}
            </Grid>
            <Grid item xs={12} md={6}>
              <div>
                {!isMobile && (
                  <Typography variant="subtitle2">{descriptionText}</Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4" sx={{ mb: '20px' }}>
                <br />
                SIM Card Details
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Type</TableCell>
                      <TableCell>Mobile Number</TableCell>
                      <TableCell>ICCID No.</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>New sign-up</TableCell>
                      <TableCell>{formData.msisdn}</TableCell>
                      <TableCell>{formData.iccid}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth style={{ textAlign: 'start' }}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ marginTop: '10px' }}
                >
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      <b>International Calls Preferences</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Typography variant="subtitle2" style={{ marginBottom: 0 }}>
                      You wish to receive international calls
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <RadioGroup
                      row
                      value={formData.biic}
                      onChange={onBiicChange}
                    >
                      <FormControlLabel
                        value="YES"
                        control={<Radio size="small" />}
                        label="YES"
                      />
                      <FormControlLabel
                        value="NO"
                        control={<Radio size="small" />}
                        label="NO"
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ marginTop: '20px' }}
                >
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      <b>International SMS Preferences</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Typography variant="subtitle2" style={{ marginBottom: 0 }}>
                      You wish to receive international SMS
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <RadioGroup
                      row
                      value={formData.biis}
                      onChange={onBiisChange}
                    >
                      <FormControlLabel
                        value="YES"
                        control={<Radio size="small" />}
                        label="YES"
                      />
                      <FormControlLabel
                        value="NO"
                        control={<Radio size="small" />}
                        label="NO"
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </FormControl>
              <Typography
                variant="subtitle2"
                sx={{
                  ...(!isMobile
                    ? { margin: '20px 0px' }
                    : { margin: '20px 0px 0px 0px' }),
                }}
              >
                Note: By selecting "Yes", you may receive fraudulent or scam
                calls / SMS from overseas numbers.
              </Typography>
              <FormControlLabel
                sx={{ marginTop: '15px', alignItems: 'self-start' }}
                control={
                  <Checkbox
                    sx={{ padding: '2px 9px' }}
                    value={isConsented}
                    checked={isConsented}
                    onChange={(e) => {
                      setIsConsent(e.target.checked)
                    }}
                  />
                }
                label={
                  <Typography variant="subtitle2">
                    I have read and I agree to the terms of the{' '}
                    <Link
                      href="https://www.m1.com.sg/data-protection"
                      target="_blank"
                      rel="noopener"
                    >
                      M1 Data Protection Policy
                    </Link>
                    ,{' '}
                    <Link
                      href="https://www.m1.com.sg/terms-and-conditions/m-card"
                      target="_blank"
                      rel="noopener"
                    >
                      M1 Prepaid Mobile Services
                    </Link>{' '}
                    and{' '}
                    <Link
                      href="https://www.m1.com.sg/terms-and-conditions"
                      target="_blank"
                      rel="noopener"
                    >
                      General Terms & Conditions
                    </Link>
                    .
                  </Typography>
                }
              />
            </Grid>

            {isMobile && (
              <Grid item xs={12}>
                <br />
                {<Typography variant="subtitle2">{descriptionText}</Typography>}
              </Grid>
            )}
          </Grid>
          <Grid
            container
            columnSpacing={1}
            direction={{ xs: 'column-reverse', md: 'row' }}
            justifyContent={{ md: 'flex-end' }}
            sx={{ p: { xs: '0 20px', md: '0 0 0 65px' } }}
          >
            <Grid item xs={12} md={3}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={handleBack}
              >
                Back
              </Button>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                disabled={!formData.biic || !formData.biis || !isConsented}
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
              >
                Register
              </Button>
            </Grid>
          </Grid>
        </>
      }
    />
  )
}

Step3.propTypes = {
  step: PropTypes.object.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default Step3
